// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"b946bad1","184":"4e09afb6","209":"8a1b94fd","426":"77ab2d9d"}[chunkId] + ".chunk.js";
};